import {HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
// import {ApiToken} from '../../model/ApiToken';




@Injectable({
  providedIn: 'root'
})
export class ApiUtils {

  // Api Token


  // CURRENT_ACCESS_TOKEN: string = '6qNt8MM7F0swcVnVQBDtA2rfR+NYtyub7Ss/eJwqqCK5pFCyU0j0QNUN/JnkqybHCRc=';
  // CURRENT_ACCESS_TOKEN: string = '4nsI2zzoHeYK6GNt5mJyc1IsswYD3vb/m0Fw3Uc7JBoT2wsR66JLNwcuKt4TM+SqGyo=';

  tokenSaved: any;

  constructor() {

   /*  const token = JSON.parse(localStorage.getItem('bessalel_store_token'));

    if (token !== null) {
      this.CURRENT_ACCESS_TOKEN = token.value;
    } */

    /* if (localStorage.getItem('tenant') !== null) {
      this.TENANTDB = JSON.parse(localStorage.getItem('tenant'));
    } */

  }


  get CURRENT_ACCESS_TOKEN() {

    let CURRENT_ACCESS_TOKEN = '';
    const token = JSON.parse(localStorage.getItem('bessalel_store_token'));

    if (token !== null) {
      CURRENT_ACCESS_TOKEN = token.value;
    }

    return CURRENT_ACCESS_TOKEN;
  }


  BASIC_API_REQUEST_HEADER(): HttpHeaders {

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      // 'X-Auth-Token': this.CURRENT_ACCESS_TOKEN,
      // 'X-Tenant': this.TENANTDB,
    });


  }

  SECURE_API_REQUEST_HEADER() {

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Auth-Token': this.CURRENT_ACCESS_TOKEN,
      // 'X-Tenant': this.TENANTDB,
    });

  }

  SECURE_API_REQUEST_HEADER_WITHOUT_CONTENT_TYPE() {

    return new HttpHeaders({
      'X-Auth-Token': this.CURRENT_ACCESS_TOKEN,
      // 'X-Tenant': this.TENANTDB,
    });

  }

  /*
  DEFAULT_API_REQUEST_HEADER(): HttpHeaders {

    return new HttpHeaders({

      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": "Bearer " + this.CURRENT_ACCESS_TOKEN
    });

  }

  MULTIPART_API_REQUEST_HEADER(): HttpHeaders {

  return new HttpHeaders({

        "Accept": "application/json",
        "Authorization": this.fullAccessToken()
      });
  }


  get JSON_API_REQUEST_HEADER(): HttpHeaders {


    return new HttpHeaders({

      "Content-Type": "application/json",
      "Accept": "application/json",
      "Authorization": this.fullAccessToken()
    });


  }

  setFullAccessToken(apiToken: ApiToken) {

    this.CURRENT_ACCESS_TOKEN = apiToken.access_token;
  }


  fullAccessToken() {

    let final_token: string = null;
    this.tokenSaved = JSON.parse(localStorage.getItem('apiToken'));

    this.tokenSaved = JSON.parse(localStorage.getItem('apiToken'));


    if (this.tokenSaved != null && this.tokenSaved != "") {


      this.CURRENT_USER_ACCESS_TOKEN = this.tokenSaved.access_token;


      final_token = "Bearer " + this.tokenSaved.access_token;

    } else {

      final_token = "Bearer " + null;

    }

    return final_token;
  }

  fullAccessToken2() {

    return "6mGBP1XqtiqnyXZL39p4OTnsneVEWCNcccIo7WRq4IW4l6iMia3hVgI70fvwEjWl5sERqS3UXqcSvJgJkSHMVc6kBgagDl2TriUbf2TP48";
  }

 */

}
